import type { FC } from "react"
import { CartesianGrid } from "recharts"

const Grid: FC = () => <CartesianGrid stroke="#EBF0F7" vertical={false} />

export default Grid
